import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface SkillCoverageChartProps {
  coverageMap: Record<string, number>;
}

const CATEGORY_COLORS: Record<string, string> = {
  skill: '#6366f1',
  methodology: '#8b5cf6',
  leadership: '#ec4899',
  industry: '#f59e0b',
  tool: '#10b981',
  client_level: '#06b6d4',
  project_type: '#f97316',
  certification: '#64748b'
};

export function SkillCoverageChart({ coverageMap }: SkillCoverageChartProps) {
  const data = Object.entries(coverageMap)
    .map(([category, percentage]) => ({
      category: category.replace(/_/g, ' '),
      percentage,
      fill: CATEGORY_COLORS[category] ?? '#94a3b8'
    }))
    .sort((a, b) => b.percentage - a.percentage);

  if (data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-sm">Skill Coverage by Category</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            No coverage data yet. Click "Refresh Team Profile" to generate.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Skill Coverage by Category</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={data.length * 40 + 20}>
          <BarChart
            layout="vertical"
            data={data}
            margin={{ top: 0, right: 20, bottom: 0, left: 80 }}
          >
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" domain={[0, 100]} tickFormatter={(v) => `${v}%`} fontSize={11} />
            <YAxis type="category" dataKey="category" fontSize={11} width={75} />
            <Tooltip formatter={(value) => [`${value}%`, 'Coverage']} />
            <Bar dataKey="percentage" radius={[0, 4, 4, 0]}>
              {data.map((entry, i) => (
                <Cell key={i} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
